module.exports = __webpack_public_path__ + "img/partner25.6584a3a0.png";